import { render, staticRenderFns } from "./AdjustAiCredits.vue?vue&type=template&id=135f4bcc&scoped=true"
import script from "./AdjustAiCredits.vue?vue&type=script&lang=js"
export * from "./AdjustAiCredits.vue?vue&type=script&lang=js"
import style0 from "./AdjustAiCredits.vue?vue&type=style&index=0&id=135f4bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f4bcc",
  null
  
)

export default component.exports